import React from "react";
import { Heart, MapPin } from "lucide-react";

export const Hero = () => {
  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative liea-grain"
      style={{
        background:
          "linear-gradient(180deg, #fbf7f1 0%, #f4ece2 60%, #ebded1 100%)",
        paddingTop: "120px",
        paddingBottom: "100px",
      }}
    >
      <div className="liea-container grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-6 relative z-10">
          <div className="liea-rise">
            <span className="liea-eyebrow">Gifting concierge</span>
          </div>

          <h1
            className="liea-rise liea-delay-1 mt-5 text-[44px] sm:text-[56px] lg:text-[72px] leading-[1.02] tracking-tight"
            style={{ color: "var(--liea-ink)" }}
          >
            Never miss a moment{" "}
            <em
              style={{
                color: "var(--liea-forest)",
                fontStyle: "italic",
                fontWeight: 500,
              }}
            >
              that matters
            </em>
            <span style={{ color: "var(--liea-terracotta)" }}>.</span>
          </h1>

          <p
            className="liea-rise liea-delay-2 mt-7 text-base md:text-lg max-w-[540px] leading-relaxed"
            style={{ color: "var(--liea-warm-grey)" }}
          >
            Liéa is a gifting concierge that remembers every important occasion,
            recommends thoughtful gifts through trusted vendor partnerships, and
            manages preparation and delivery for you.
          </p>

          <div className="liea-rise liea-delay-3 mt-9 flex flex-wrap gap-3">
            <a
              href="#for-customers"
              data-testid="hero-cta-customer"
              className="liea-btn-accent inline-flex items-center gap-2 px-6 py-3.5 rounded-full text-[15px] font-medium"
            >
              <Heart size={16} strokeWidth={2} />
              I&rsquo;m sending a gift
            </a>
            <a
              href="#for-vendors"
              data-testid="hero-cta-vendor"
              className="liea-btn-ghost inline-flex items-center gap-2 px-6 py-3.5 rounded-full text-[15px] font-medium"
            >
              I&rsquo;m a vendor
            </a>
          </div>

          <div className="liea-rise liea-delay-4 mt-10 flex items-center gap-5 text-sm" style={{ color: "var(--liea-sage)" }}>
            <div className="flex items-center gap-2">
              <MapPin size={14} />
              <span>Caribbean · Canada · US</span>
            </div>
          </div>
        </div>

        <div className="lg:col-span-6 relative">
          <div className="relative liea-rise liea-delay-2 max-w-[420px] mx-auto">
            <div className="liea-phone-frame">
              <img
                src="/assets/Home_screen_recommendations.jpeg"
                alt="Liéa home screen with upcoming occasion recommendation"
                style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "inherit" }}
              />
            </div>

            {/* Floating accent card */}
            <div
              className="hidden md:flex absolute -left-10 bottom-16 items-center gap-3 px-4 py-3 rounded-2xl liea-rise liea-delay-4"
              style={{
                background: "#ffffff",
                border: "1px solid rgba(149, 159, 133, 0.25)",
                boxShadow: "0 18px 40px -22px rgba(64, 83, 68, 0.35)",
              }}
            >
              <div
                className="w-9 h-9 rounded-full flex items-center justify-center"
                style={{
                  background: "rgba(212, 131, 79, 0.15)",
                  color: "var(--liea-terracotta)",
                }}
              >
                <Heart size={16} fill="currentColor" />
              </div>
              <div>
                <p
                  className="text-xs font-medium"
                  style={{ color: "var(--liea-warm-grey)" }}
                >
                  Mum&rsquo;s birthday
                </p>
                <p
                  className="text-sm font-serif"
                  style={{ color: "var(--liea-ink)" }}
                >
                  in 6 days
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
